import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/protected/_layout/administration/_layout/'
)({
  component: () => null,
});
